import React from 'react';
import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import s from './ExactMatchHeadlineSkeleton.css';
export const ExactMatchHeadlineSkeleton = _ref => {
  let {
    dataHook = 'exact-match-headline-skeleton'
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center",
    paddingBottom: "SP3",
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light",
    className: s.skeletonGroup
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "500px",
    height: "26px"
  })));
};
//# sourceMappingURL=ExactMatchHeadlineSkeleton.js.map